import { h } from '../dom.js';

export function SiteNav(): HTMLElement {
  return h('nav', { className: 'site-nav', attrs: { 'aria-label': '主导航' } }, [
    h('a', { className: 'site-nav__link', text: '主页', attrs: { href: '/' } }),
    h('a', {
      className: 'site-nav__link site-nav__link--active',
      text: '日语学习',
      attrs: { href: '/nihongo/', 'aria-current': 'page' },
    }),
    h('a', { className: 'site-nav__link', text: 'YouTube', attrs: { href: '/youtube/' } }),
  ]);
}
